<template>
    <v-card flat class="conteneurLead" id="conteneurLead" style="width: 100%;">
        <v-card-title class="primary white--text"  style="height: 52px;  padding: 0px;">
          <v-btn icon @click="$emit('justCloseDialogConfirm')"><v-icon class="white--text">close</v-icon></v-btn>
          <div class="title tf_title_dialog" v-html="titleDialogConfirm"></div>
          <v-spacer></v-spacer>
          <v-btn v-if="$vuetify.breakpoint.smAndDown" flat @click="submitDialogConfirm()" class="white--text">{{ $t('submit') }}</v-btn>
        </v-card-title>
        <v-card-text>
          <v-layout row wrap justify-space-between>

            <v-flex xs12>
							<div v-if="!loadingRes && !contentDialogRes.length" v-html="contentDialogConfirm"></div>
							<div v-else class="tf_loading_url">
								<div class="tf_contentLoading">
									<div v-if="loadingRes" class="text-xs-center">
										<v-progress-circular
											:rotate="-90"
											:size="120"
											:width="8"
											:value="loadingValue"
											color="primary"
										>
											{{ loadingValue }} %
										</v-progress-circular>
									</div>
									<div v-if="contentDialogRes.length" class="tf_contentLoadingTxt">
										<div class="contentLoading" v-html="contentDialogRes"></div>
									</div>
								</div>
							</div>

            </v-flex>
            <v-flex xs12 v-if="!contentDialogRes.length">
              <p><v-spacer></v-spacer></p>
              <v-divider ></v-divider>
              <p><v-spacer></v-spacer></p>
            </v-flex>
            <!-- Actions pour la selection -->
						<v-flex xs12 v-if="!contentDialogRes.length">
              Choissez le mode de recherche :<br>
							<v-select
								v-model="selectActionUrl"
								:items="computedActionUrl"
								item-text="text"
								item-value="id"
								:label="$t('actions')"
								@change="actionsUrl()"
							>
							</v-select>
              <v-spacer></v-spacer>
              <v-text-field
                v-if="selectActionUrl === 'crawler-allurl-page'"
                :label="this.$t('AIDataScann')"
                v-model="page"
              ></v-text-field>
              <v-checkbox
                v-model="checkboxMAJ"
                :label="this.$t('AIDataMAJAuto')"
                required
              ></v-checkbox>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions v-if="!$vuetify.breakpoint.smAndDown && !closeDialogUniquement && !modifBaseCo">
          <v-spacer></v-spacer>
          <v-btn v-if="!loadingModifFAQ" flat @click="closeDialogConfirm()">{{ $t('no') }}</v-btn>
          <v-btn 
            :loading="loadingModifFAQ"
            :disabled="!selectActionUrl.length"
            color="primary"
            @click="submitDialogConfirm()"
          >{{ $t('search') }}</v-btn>
        </v-card-actions>
        <v-card-actions v-else-if="!$vuetify.breakpoint.smAndDown && !closeDialogUniquement && modifBaseCo">
          <v-spacer></v-spacer>
          <v-btn flat @click="$emit('justCloseDialogConfirm')">{{ $t('close') }}</v-btn>
          <v-btn color="primary" @click="$emit('closeDialogConfirm')">{{ $t('ok') }}</v-btn>
        </v-card-actions>
        <v-card-actions v-else>
          <v-spacer></v-spacer>
          <v-btn flat @click="closeDialogConfirm()">{{ $t('close') }}</v-btn>
        </v-card-actions>
    </v-card>
</template>



<script>
export default {
  props: {
    showDialogConfirmation: {
      type: Boolean,
      default: false
    },
    loadingModifFAQ: {
      type: Boolean,
      default: false
    },
    loadingRes: {
      type: Boolean,
      default: false
    },
    contentDialogConfirm: {
      type: String,
      default: ''
    },
    contentDialogRes: {
      type: String,
      default: ''
    },
    titleDialogConfirm: {
      type: String,
      default: 'Confirmation'
    },
    closeDialogUniquement: {
      type: Boolean,
      default: false
    },
    modifBaseCo: {
      type: Boolean,
      default: false
    },
    startLoading: {
      type: Number,
      default: 0
    },
    endLoading: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      selectActionUrl: [],
      checkboxMAJ: false,
      page: ''
    }
  },
  computed: {
    computedActionUrl () {
      let actions = [
        {text: this.$t('scanneSitemap'), id: 'crawler-sitemap'},
        {text: this.$t('scanneSite'), id: 'crawler-allurl'},
        {text: this.$t('scannePage'), id: 'crawler-allurl-page'}
      ]
      return actions
    },
    loadingValue () {
      return Math.round((this.startLoading * 100) / this.endLoading)
    }
  },
  mounted () {},
  updated () {},
  methods: {
    closeDialogConfirm () {
      if (!this.closeDialogUniquement) {
        this.$emit('closeDialogConfirm')
      } else {
        this.$emit('justCloseDialogConfirm')
      }
    },
    submitDialogConfirm () {
      this.$emit('submitDialogConfirm', this.selectActionUrl, this.checkboxMAJ, this.page)
    },
    // selection de l'action dans le menu déroulant pour les url
    actionsUrl () {
      console.log('this.selectActionUrl', this.selectActionUrl)
      if (this.selectActionUrl === 'sitemap') {
        // this.showDialogDelete = true
        console.log('selectedUrls', this.selectedUrls)
      } else if (this.selectActionUrl === 'siteweb') {
        // this.showDialogAddKeyword = true
        console.log('add keywords', this.selectedUrls)
      } else {
      }
    }
  }
}
</script>

<style scoped>
  .tf_title_dialog {
    text-overflow: ellipsis;
    width: calc(100% - 180px);
    overflow: hidden;
    white-space: nowrap;
  }
  .tf_loading_url {
    height: 400px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
  }
  .tf_text_url {
    height: 400px;
    display: flex;
    flex-direction: column;
  }
  .contentLoading {
    padding-top: 20px;
  }
  .v-progress-circular {
    margin: 1rem;
  }
  .v-progress-circular__overlay {
    stroke: currentColor;
    z-index: 2;
    transition: all 0.6s ease-in-out;
  }
  .tf_contentLoading{
    height: 100%;
    width: 100%;
  }

  .contentLoading {
    height: 100%;
    padding-bottom: 20px;
  }
  .tf_contentLoading h3 {
    text-align: left;
  }
  .loadingNum {
    text-align: center;
  }
  .tf_contentLoading .listeUrlsError {
    text-align: left;
  }
  .tf_contentLoading .listeUrlsError li {
    font-weight: 500;
  }
</style>



// WEBPACK FOOTER //
// src/components/watcheezy/WzDialogAddUrls.vue